import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Network = createReactComponent("Network", ["svg", defaultAttributes, [["rect", {
  x: "9",
  y: "2",
  width: "6",
  height: "6",
  key: "gjave5"
}], ["rect", {
  x: "16",
  y: "16",
  width: "6",
  height: "6",
  key: "1hz3r1"
}], ["rect", {
  x: "2",
  y: "16",
  width: "6",
  height: "6",
  key: "pc2xv7"
}], ["path", {
  d: "M12 8v4m0 0H5v4m7-4h7v4",
  key: "14mn3q"
}]]]);
export default Network;